import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import QuoteBuilder from "@/pages/QuoteBuilder";
import SettingsHub from "@/pages/SettingsHub";
import Settings from "@/pages/Settings";
import PricingTables from "@/pages/PricingTables";
import Jobs from "@/pages/Jobs";
import ProductLibrary from "@/pages/ProductLibrary";
import SupplierColours from "@/pages/SupplierColours";
import Customers from "@/pages/Customers";
import PublicQuote from "@/pages/PublicQuote";
import UserManagement from "@/pages/UserManagement";
import RetailCalculator from "@/pages/RetailCalculator";
import RetailPricing from "@/pages/RetailPricing";
import Analytics from "@/pages/Analytics";
import QuoteTemplates from "@/pages/QuoteTemplates";
import PricingIntelligence from "@/pages/PricingIntelligence";
import EmailInbox from "@/pages/EmailInbox";
import EmailThread from "@/pages/EmailThread";
import { setupGlobalErrorHandler } from "@/utils/errorLogger";

function App() {
  // Setup global error handler on mount
  useEffect(() => {
    setupGlobalErrorHandler();
  }, []);
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/public/quote/:token" element={<PublicQuote />} />
            
            {/* Protected routes - require authentication */}
            <Route path="/" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/quote" element={
              <ProtectedRoute>
                <QuoteBuilder />
              </ProtectedRoute>
            } />
            <Route path="/quote/:jobId" element={
              <ProtectedRoute>
                <QuoteBuilder />
              </ProtectedRoute>
            } />
            <Route path="/jobs" element={
              <ProtectedRoute>
                <Jobs />
              </ProtectedRoute>
            } />
            <Route path="/products" element={
              <ProtectedRoute>
                <ProductLibrary />
              </ProtectedRoute>
            } />
            <Route path="/supplier-colours" element={
              <ProtectedRoute>
                <SupplierColours />
              </ProtectedRoute>
            } />
            <Route path="/retail" element={<Navigate to="/quote?new=retail" replace />} />
            <Route path="/retail/new" element={<Navigate to="/quote?new=retail" replace />} />
            <Route path="/retail-calculator" element={
              <ProtectedRoute>
                <RetailCalculator />
              </ProtectedRoute>
            } />
            
            {/* Admin-only routes - Settings hub and sub-pages */}
            <Route path="/settings" element={
              <ProtectedRoute requireAdmin>
                <SettingsHub />
              </ProtectedRoute>
            } />
            <Route path="/settings/pricing" element={
              <ProtectedRoute requireAdmin>
                <PricingTables />
              </ProtectedRoute>
            } />
            <Route path="/settings/retail-pricing" element={
              <ProtectedRoute requireAdmin>
                <RetailPricing />
              </ProtectedRoute>
            } />
            <Route path="/settings/analytics" element={
              <ProtectedRoute requireAdmin>
                <Analytics />
              </ProtectedRoute>
            } />
            <Route path="/settings/users" element={
              <ProtectedRoute requireAdmin>
                <UserManagement />
              </ProtectedRoute>
            } />
            <Route path="/settings/branding" element={
              <ProtectedRoute requireAdmin>
                <Settings />
              </ProtectedRoute>
            } />
            <Route path="/settings/print-methods" element={<Navigate to="/settings?section=pricing" replace />} />
            <Route path="/settings/templates" element={
              <ProtectedRoute requireAdmin>
                <QuoteTemplates />
              </ProtectedRoute>
            } />
            <Route path="/reports/pricing-intelligence" element={
              <ProtectedRoute requireAdmin>
                <PricingIntelligence />
              </ProtectedRoute>
            } />
            <Route path="/inbox" element={
              <ProtectedRoute>
                <EmailInbox />
              </ProtectedRoute>
            } />
            <Route path="/inbox/thread/:threadId" element={
              <ProtectedRoute>
                <EmailThread />
              </ProtectedRoute>
            } />
            <Route path="/customers" element={
              <ProtectedRoute>
                <Customers />
              </ProtectedRoute>
            } />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
